import { createContext, useContext, useState } from "react";
import { authFetch } from "../../api";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [profileStatus, setProfileStatus] = useState(null);
  const userId = localStorage.getItem("userId");

  const checkUserProfile = async () => {
    setLoading(true);
    setProfileStatus(null);

    try {
      const res = await authFetch(
        "application/check-user-data-for-profile-section",
        {
          method: "POST",
          body: JSON.stringify({ user_id: userId }),
          headers: { "Content-Type": "application/json" },
        }
      );

      // parse json correctly
      const responseData = await res.json();

      // store in state
      setProfileStatus(responseData);

      // return parsed API data (NOT res.data)
      return responseData;
    } catch (error) {
      const backendError = error?.response?.data;

      const extractedError = {
        success: false,
        message: backendError?.error || "Unknown error occurred",
      };

      setProfileStatus(extractedError);
      return extractedError;
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProfileContext.Provider
      value={{
        loading,
        profileStatus,
        checkUserProfile,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);
